import { inject } from '../../../../../../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../../service/LearningRootService';
import { IProjectLearningReportArg } from '../../../../../../service/report/interface/IProjectLearningReportArg';
import { IProjectRatingsDomain } from './IProjectRatingsDomain';

export class ProjectRatingsDomain implements IProjectRatingsDomain {
  constructor(
    protected learningRootService = inject<ILearningRootService>(LearningRootServiceToken),
  ) {}

  getProjectRatings = (arg: IProjectLearningReportArg = {}) => this.learningRootService.report.getProjectRatings(arg);
}
